  <app-view-details [title]="isArabic() ? 'الحد الاقصى لطلب الصنف' : 'Product Order Limit'" [fields]="fields()">
    <button
      header-action
      type="button"
      (click)="editRequested.emit()"
      class="borderTabsColor textTabsColor cursor-pointer rounded-lg border bg-white px-4 py-1 text-xs font-semibold">
      {{ isArabic() ? "إعادة تعيين" : "Reset" }}
    </button>
  </app-view-details>
